export const SCHOOL_COOKIE_NAME = 'Authorization';
export const STUDENT_COOKIE_NAME = 'Student-Authorization';
export const STUDENT_ROOM_INFO_COOKIE_NAME = 'room-info';
export const CSRF_TOKEN_COOKIE_NAME = 'csrf-token';
